import { Component, OnInit } from '@angular/core';
import { RouteInfo } from '../../interfaces/route-info.interface';
import { AuthService } from '../../services/auth/auth.service';
import packageInfo from '../../../../package.json';

export const ROUTES: RouteInfo[] = [
  {
    path: '/dashboard',
    title: 'nav.dashboard',
    icon: 'space_dashboard',
    class: '',
    roles: ['Admin', 'Coordinadora'],
  },
  {
    path: '/stats',
    title: 'nav.stats',
    icon: 'query_stats',
    class: '',
    roles: ['Admin', 'Coordinadora'],
  },
  {
    path: '/appointments',
    title: 'nav.appointments',
    icon: 'event',
    class: '',
    roles: ['Admin', 'Coordinadora', 'Auxiliar'],
  },
  {
    path: '/budgets',
    title: 'nav.budgets',
    icon: 'request_quote',
    class: '',
    roles: ['Admin', 'Coordinadora'],
  },
  {
    path: '/patients',
    title: 'nav.patients',
    icon: 'groups',
    class: '',
    roles: ['Admin', 'Coordinadora', 'Auxiliar'],
  },
  {
    path: '/recalls',
    title: 'nav.recalls',
    icon: 'notifications_active',
    class: '',
    roles: ['Admin', 'Coordinadora', 'Auxiliar'],
  },
  {
    path: '/feedback',
    title: 'nav.feedback',
    icon: 'reviews',
    class: '',
    roles: ['Admin', 'Coordinadora'],
  },
  {
    path: '/fichajes',
    title: 'nav.attendance',
    icon: 'badge',
    class: '',
    roles: ['Admin', 'Coordinadora', 'Auxiliar'],
  },
  {
    path: '/templates',
    title: 'nav.templates',
    icon: 'description',
    class: '',
    roles: ['Coordinadora', 'MetaReviewer'],
  },
  {
    path: '/whatsapp',
    title: 'nav.whatsapp',
    icon: 'forum',
    class: '',
    roles: ['Admin', 'Coordinadora', 'Auxiliar', 'MetaReviewer'],
  },
  {
    path: '/config/whatsapp',
    title: 'nav.whatsappConnection',
    icon: 'link',
    class: '',
    roles: ['MetaReviewer'],
  },
  {
    path: '/config',
    title: 'nav.settings',
    icon: 'settings',
    class: '',
    roles: ['Admin'],
  },

  // { path: '/user-profile', title: 'User Profile', icon: 'person', class: '' },
  // {
  //   path: '/table-list',
  //   title: 'Table List',
  //   icon: 'content_paste',
  //   class: '',
  // },
  // {
  //   path: '/typography',‚
  //   title: 'Typography',
  //   icon: 'library_books',
  //   class: '',
  // },
  // { path: '/icons', title: 'Icons', icon: 'bubble_chart', class: '' },
  // { path: '/maps', title: 'Maps', icon: 'location_on', class: '' },
  // {
  //   path: '/notifications',
  //   title: 'Notifications',
  //   icon: 'notifications',
  //   class: '',
  // },
  // {
  //   path: '/upgrade',
  //   title: 'Upgrade to PRO',
  //   icon: 'unarchive',
  //   class: 'active-pro',
  // },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false,
})
export class SidebarComponent implements OnInit {
  menuItems: any[];
  readonly appVersion = packageInfo.version;

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.menuItems = ROUTES.filter((menuItem) => {
      if (!menuItem.roles || menuItem.roles.length === 0) {
        return true;
      }

      return this.authService.hasRole(menuItem.roles);
    });
  }
}
